import { styled } from '@mui/system';
import colors from '../../vars.module.scss';
import { Button, Link } from '@mui/material';

// Styled components
export const StyledTextArea = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const StyledActionButton = styled(Button)(({ theme, className = '' }) => ({
  color: colors.whiteColor,
  backgroundColor: className.includes('primary-dark-color-btn') ? colors.primaryDarkColor : colors.secondaryColor,
  '&:hover': {
    backgroundColor: className.includes('primary-dark-color-btn') ? colors.primaryDarkColor : colors.secondaryColor,
  },
  margin: '0px 1%',
}));

export const StyledBreadcrumbLink = styled(Link)(({ theme, className = '' }) => ({
  fontSize: '1em',
  fontWeight: 700,
  textDecoration: 'none',
  color: className.includes('link-color') ? colors.primaryDarkColor : colors.textLightShade,
  '&:hover': {
    color: className.includes('link-color') ? colors.primaryDarkColor : colors.textLightShade,
    textDecoration: 'underline',
  },
}));

export const StyledMobileBackButton = styled('div')(({ theme }) => ({
  margin: '10px 0px',
}));
